module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp13_8017.4c8088b2.png";